import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getWebsitePages(websiteId, params = {}) {
  return axios.get(`/ajax/websites/${websiteId}/website_pages`, { params })
}
export function getWebsitePage(id) {
  return axios.get(`/ajax/website_pages/${id}`)
}
export function createWebsitePage(websiteId, data) {
  return axios.post(`/ajax/websites/${websiteId}/website_pages`, data)
}
export function updateWebsitePage(id, data) {
  return axios.patch(`/ajax/website_pages/${id}`, data)
}
export function destroyWebsitePage(id) {
  return axios.delete(`/ajax/website_pages/${id}`)
}
export function extractPageContent(id) {
  return axios.post(`/ajax/website_pages/${id}/extract_content`)
}
export function updatePageContent(id, content) {
  return axios.post(`/ajax/website_pages/${id}/update_content`, { extracted_content: content })
}
export function enablePageGa(id) {
  return axios.post(`/ajax/website_pages/${id}/enable_ga`)
}
export function enablePageGsc(id) {
  return axios.post(`/ajax/website_pages/${id}/enable_gsc`)
}
export function disablePageGa(id) {
  return axios.post(`/ajax/website_pages/${id}/disable_ga`)
}
export function disablePageGsc(id) {
  return axios.post(`/ajax/website_pages/${id}/disable_gsc`)
}
export function getPageGaStats(id, params = {}) {
  return axios.get(`/ajax/website_pages/${id}/ga_stats`, { params })
}
export function getPageGscStats(id, params = {}) {
  return axios.get(`/ajax/website_pages/${id}/gsc_stats`, { params })
}
export function getPageGscQueries(id, params = {}) {
  return axios.get(`/ajax/website_pages/${id}/gsc_queries`, { params })
}
export function computePriorityScores(websiteId) {
  return axios.post(`/ajax/websites/${websiteId}/compute_priority_scores`)
}
export function publishToWp(id, data) {
  return axios.post(`/ajax/website_pages/${id}/publish_to_wp`, data)
}
export function generatePublishImages(id, data) {
  return axios.post(`/ajax/website_pages/${id}/generate_publish_images`, data)
}
export function regeneratePublishImage(id, data) {
  return axios.post(`/ajax/website_pages/${id}/regenerate_publish_image`, data)
}
export function confirmPublishToWp(id, data) {
  return axios.post(`/ajax/website_pages/${id}/confirm_publish_to_wp`, data)
}
